import AwsS3 from 'aws-sdk/clients/s3';
import Dynamipay, { SERVICES } from 'services/dynamipay';
import {
  AWS_BUCKET as BUCKET,
  AWS_CREDENTIALS as CREDENTIALS,
  AWS_REGION as REGION,
} from 'settings/aws';

const client = new AwsS3({
  apiVersion: '2006-03-01',
  region: REGION,
  credentials: CREDENTIALS,
});

export async function checkKeyExist(path, repository = BUCKET) {
  const key = path.replace(`https://${repository}.s3.${REGION}.amazonaws.com/`, '');
  const params = {
    Bucket: repository,
    Key: key,
  };

  try {
    await client
      .headObject(params)
      .promise();

    return true;
  } catch (e) {
    return false;
  }
}

/**
* Download file from AWS S3
*
* @param {string} path
*/
export async function download(path) {
  try {
    const url = await getSignedUrl(path);
    window.open(url);
  } catch (error) {
    return false;
  }

  return true;
}

/**
 * Get signed URL
 *
 * @param {string} path
 */
export async function getSignedUrl(path, expires = 10, repository = BUCKET) {
  // path = (path ?? '').replace(`https://${repository}.s3.${REGION}.amazonaws.com/`, '');
  path = (path ?? '').replace(`https://${repository}.s3.us-east-1.amazonaws.com/`, '');

  const url = await Dynamipay(SERVICES.REPORT_SIGNIN_DOCUMENT).post({
    bucket: repository,
    expires,
    key: path,
  });

  return url;
}

/**
* Upload file to AWS S3
*
* @param {string} path
* @param {(Buffer|Uint8Array|Blob|string|Readable)} file
* @param {object} metadata
*/
export async function upload(path, file, metadata = {}) {
  const objMetadata = {};
  Object
    .keys(metadata)
    .forEach((key) => {
      objMetadata[key] = String(metadata[key]);
    });

  const params = {
    Body: file,
    Bucket: BUCKET,
    ContentType: file.type,
    Key: path,
    Metadata: {
      ...objMetadata,
      'app-client': 'dynamicore-web-admin',
    },
  };
  const options = {
    partSize: 50 * 1024 * 1024,
    queueSize: 1,
  };

  return client.upload(params, options).promise();
}

export async function uploadFile(path, file, metadata = {}, companyId, commerceId) {
  if (path.startsWith('company/')) {
    [, companyId] = path.split('/');
    path = path.replace(`company/${companyId}`, '');
  }

  const payload = {
    bucket: BUCKET,
    company: companyId,
    expires: 60 * 10,
    key: path,
    commerce: commerceId,
  };

  const presigned = await Dynamipay(SERVICES.USERS_PRESIGNIN_DOCUMENT).post(payload);

  const formData = new FormData();
  Object.entries(presigned.fields).forEach(([k, v]) => {
    formData.append(k, v);
  });
  formData.append('file', new Blob([file]));

  await fetch(presigned.url, {
    method: 'POST',
    body: formData,
  });

  return {
    Location: `https://${BUCKET}.s3.${REGION}.amazonaws.com/${presigned.fields.key}`,
  };
}
